import { ValidatedConciergeTreatmentSchema } from "@redotech/redo-model/ab-tests/concierge";
import { object, string } from "zod/v4";

export const getConciergeTreatment = {
  name: "getConciergeTreatment" as const,
  input: object({ desiredTreatmentId: string().optional() }),
  output: object({
    conciergeTreatment: ValidatedConciergeTreatmentSchema.optional(),
  }),
};
